import { ErrorOutline } from '@mui/icons-material';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import aiMusicGenerator from 'services/locales/en/aiMusicGenerator';

const TrackError = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplate: {
          xs: `'errorIcon errorMessage errorMessage errorMessage errorMessage errorMessage'
               '.         .            .            retryButton  retryButton  retryButton'`,
          md: `'errorIcon errorMessage errorMessage retryButton retryButton retryButton'`,
          lg: `'errorIcon errorMessage errorMessage errorMessage errorMessage retryButton retryButton retryButton'`,
        },
        gridTemplateColumns: {
          xs: '10% 45% 0 10% 10% 10%',
          md: '10% 45% 20% 5% 5% 5%',
          lg: '33px 24% minmax(15%, 140px) 33px minmax(30%, 280px) 33px 33px 33px',
        },
        gridColumnGap: {
          xs: theme.spacing(1),
          lg: theme.spacing(2),
        },
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-around',
        paddingX: { xs: theme.spacing(1), md: theme.spacing(2) },
        paddingY: theme.spacing(2),
        borderTopWidth: 1,
        borderTopStyle: 'solid',
        borderTopColor: theme.palette.grey[900],
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gridArea: 'errorIcon',
        }}
      >
        <ErrorOutline style={{ color: theme.palette.grey[400] }} />
      </Box>
      <Typography
        variant="body1"
        data-testid="errorArea"
        sx={{
          color: theme.palette.grey[400],
          paddingY: theme.spacing(3),
          [theme.breakpoints.down('sm')]: {
            padding: 0,
          },
          gridArea: 'errorMessage',
        }}
      >
        {t(aiMusicGenerator.trackResults.errorMessage).toString()}
      </Typography>
      <Box sx={{ gridArea: 'retryButton' }} />
    </Box>
  );
};

export default TrackError;
